module.exports = __webpack_public_path__ + "img/snowy-church.eaa1f74d.jpg";